/** Temperature zones for daily compliance — keep in sync with backend/src/utils/complianceTemperatureZones.js */
export const TEMPERATURE_COMPLIANCE_ZONES = [
  { id: 'fridge1', name: 'Main Fridge', min: 1, max: 5, location: 'Back Area' },
  { id: 'freezer1', name: 'Main Freezer', min: -20, max: -15, location: 'Back Area' },
  { id: 'fridge2', name: 'Dairy Fridge', min: 1, max: 5, location: 'Front Area' },
  { id: 'ambient', name: 'Ambient Storage', min: 15, max: 22, location: 'Warehouse' },
];

export const normalizeTemperatureComplianceSubtaskId = (raw) => {
  const s = String(raw ?? '').trim();
  if (!s) return '';
  if (TEMPERATURE_COMPLIANCE_ZONES.some((z) => String(z.id) === s)) return s;
  const exact = TEMPERATURE_COMPLIANCE_ZONES.find((z) => z.name === s);
  if (exact) return String(exact.id);
  const lower = s.toLowerCase();
  const ci = TEMPERATURE_COMPLIANCE_ZONES.find((z) => z.name.toLowerCase() === lower);
  if (ci) return String(ci.id);
  return s;
};

/** Null when no numeric reading was stored (missing/empty/invalid). Zero is a valid reading. */
export const parseTemperatureComplianceReading = (data) => {
  if (!data || typeof data !== 'object') return null;
  const pick = (v) => {
    if (v === undefined || v === null || v === '') return null;
    const n = Number(v);
    return Number.isFinite(n) ? n : null;
  };
  const a = pick(data.temp);
  if (a !== null) return a;
  return pick(data.Temp);
};
